module.exports = __webpack_public_path__ + "bb37701d751d3f818655375aa28f91ab.png";